module.exports = __webpack_public_path__ + "img/3.6f02ba8f.png";